// Send a list of cards to the registered service worker so it can schedule
// timestamp-triggered notifications via the Notification Triggers API.
// Silently no-ops if SW or API isn't available.
export async function scheduleCardNotifications(cards) {
  if (!("serviceWorker" in navigator)) return;
  try {
    const reg = await navigator.serviceWorker.ready;
    reg.active?.postMessage({
      type: "SCHEDULE_CARD_NOTIFICATIONS",
      cards: cards.map((c) => ({
        id: c.id,
        name: c.name,
        source: c.source || "",
        target_at: c.target_at,
      })),
    });
  } catch (e) {}
}

export async function cancelScheduledNotifications() {
  if (!("serviceWorker" in navigator)) return;
  try {
    const reg = await navigator.serviceWorker.ready;
    reg.active?.postMessage({ type: "CANCEL_CARD_NOTIFICATIONS" });
  } catch (e) {}
}
